
import Vue from "vue";

import {
  payPlanChangeRequestMapState,
  payPlanChangeRequestMapActions,
  payPlanChangeRequestMapMutations
} from "@/store/modules/payplanchangerequest";
import EditPayPlanChangeRequest from "@/views/shared/PayPlanChangeRequest/SinglePayPlanChangeRequests/EditPayPlanChangeRequest.vue";

interface Idata {
  didInit: boolean;
  activeIndex: string;
  error: string;
  message: string;
  resourceNotFound: boolean;
  resourceNotFoundMsg: string;
}

export default Vue.extend({
  name: "SinglePayPlanChangeRequest",
  components: {
    EditPayPlanChangeRequest
  },
  data(): Idata {
    return {
      didInit: false,
      activeIndex: "info",
      error: "",
      message: "",
      resourceNotFound: false,
      resourceNotFoundMsg:
        "Ooops! The Pay Plan Change Request you are looking for cannot be found."
    };
  },
  async created() {
    try {
      await this.getPayPlanChangeRequest(this.payPlanChangeRequestId);
    } catch (error) {
      this.resourceNotFound = true;
      this.$bugSnagClient.notify(error);
      this.resourceNotFoundMsg = error.message;
    } finally {
      this.didInit = true;
    }
  },
  destroyed() {
    this.SET_STATE({ key: "editing", value: null });
  },
  methods: {
    ...payPlanChangeRequestMapActions(["getPayPlanChangeRequest"]),
    ...payPlanChangeRequestMapMutations(["SET_STATE"])
  },
  computed: {
    ...payPlanChangeRequestMapState(["makingApiRequest", "editing"]),
    payPlanChangeRequestId(): string {
      return this.$route.params.payplanchangerequest_id;
    }
  }
});
